import { isTurnstileError } from './turnstile';

/**
 * What went wrong with a sign-in or a sign-up, for the message the window shows above its button:
 * - turnstile: the API turned the Cloudflare check down (`extensions.code: "TURNSTILE_FAILED"`);
 * - wrong (sign-in): the email or the password don't match an account;
 * - unconfirmed (sign-in): the account exists but its email wasn't confirmed (only if confirmation becomes required again);
 * - taken (sign-up): an account already has that email (the username is the email);
 * - network: the request never reached the API (offline, the API down);
 * - server: anything else the API answered.
 */
export const authErrorKind = (error, action) => {
  if (isTurnstileError(error)) return 'turnstile';
  const graphQLErrors = error?.graphQLErrors || [];
  const message = graphQLErrors[0]?.message ?? '';
  if (graphQLErrors.length) {
    if (action === 'login') return /not confirmed/i.test(message) ? 'unconfirmed' : 'wrong';
    return /already taken/i.test(message) ? 'taken' : 'server';
  }
  // Fetch failed before any answer: no status to read
  if (error?.networkError && !error.networkError.statusCode) return 'network';
  if (error?.networkError) return 'server';
  if (error instanceof TypeError || (typeof navigator !== 'undefined' && navigator.onLine === false)) return 'network';
  return 'server';
};

// The API's own words for a failed request, for analytics only (never shown)
export const authErrorMessage = (error) => error?.graphQLErrors?.[0]?.message ?? error?.message ?? '';
